import { render } from "./BattlesHeaderOverview.vue?vue&type=template&id=36724959&scoped=true"
import script from "./BattlesHeaderOverview.vue?vue&type=script&lang=js"
export * from "./BattlesHeaderOverview.vue?vue&type=script&lang=js"

import "./BattlesHeaderOverview.vue?vue&type=style&index=0&id=36724959&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36724959"]])

export default __exports__